<ng-container *finLet="isMobile$ | async as isMobile">
  <div class="single-trip-container">
    <fcom-image
      class="picture trip-image"
      *ngIf="image"
      [ratio]="isMobile ? '1x1' : '16x9'"
      [alt]="image.alt"
      [imageData]="image"
    ></fcom-image>
    <div class="trip-info flex flex--column flex--left-center">
      <span class="flex flex--row flex--start flex--middle departure-arrival-info">
        <h2 data-testid="trip-route-header" class="font-heading-4">
          {{
            ('MMB.upcomingTrips.tripsTab.tripLocations' | finLocalization: { departure: departure, arrival: arrival }) +
              ' ' +
              (remainingTrips > 0
                ? ('MMB.upcomingTrips.tripsTab.moreTrips' | finLocalization: { numberOfTrips: remainingTrips })
                : '')
          }}
        </h2>
      </span>
      <p class="font-body-1">{{ departureDate | finDateFormat: 'FULL' }}</p>
      <p class="font-body-1">
        {{ 'MMB.upcomingTrips.tripsTab.bookingReference' | finLocalization }}
        <span data-testid="trip-booking-ref" class="bold-type">{{ bookingReference }}</span>
      </p>
    </div>
    <ng-container
      *ngIf="!isMobile"
      [ngTemplateOutlet]="link"
      [ngTemplateOutletContext]="{ isMobile: isMobile }"
    ></ng-container>
  </div>
  <ng-container
    *ngIf="isMobile"
    [ngTemplateOutlet]="link"
    [ngTemplateOutletContext]="{ isMobile: isMobile }"
  ></ng-container>
</ng-container>
<ng-template #link let-isMobile="isMobile">
  <div class="trip-link flex flex--middle flex--end" [ngClass]="{ 'pr-small-b': isMobile }">
    <fcom-button
      [ngClass]="{ 'flex-1': !isMobile }"
      class="flex--basis0"
      data-testid="view-trip-link"
      [icon]="{ name: SvgLibraryIcon.ARROW_RIGHT, position: IconPosition.RIGHT }"
      [theme]="ButtonTheme.LIGHT_TERTIARY_GHOST"
      [mode]="ButtonMode.FILL"
      [text]="tripLinkText | finLocalization"
      (clickBtn)="onTripLinkClick()"
    ></fcom-button>
  </div>
</ng-template>
